module.exports = __webpack_public_path__ + "static/media/search.ab566cff.svg";